import {
    getBindingDriftReport,
    listBindingDriftReports,
} from './queries';

import {GraphQLQuery} from '@aws-amplify/api';
import {BindingDriftReport, BindingDriftReportSummary} from "../types.ts";
import {billingApiClient} from "../../billing-api-integration";

export type ListBindingDriftReports = {
    listBindingDriftReports: { items: BindingDriftReportSummary[], nextToken: string | null }
}

export type GetBindingDriftReport = {
    getBindingDriftReport: BindingDriftReport
}

const client = billingApiClient;

// FNP-585: read-only module. No create/update/delete — the binding-drift sweep
// (FNP-502) owns the lifecycle. listBindingDriftReports is the single list query
// (recordType-runStartedAt GSI, newest-first); it takes no sort or filter argument,
// so none is sent.
export const fetchRecords = async ({limit, nextToken}: { limit: number, nextToken: string | null }) => {
    const response = await client.graphql<GraphQLQuery<ListBindingDriftReports>>({
        query: listBindingDriftReports,
        variables: {
            limit,
            nextToken,
        },
    });
    return {
        // Guard against a GraphQL-level error (response.data undefined), so the hook
        // always receives a real array, never an undefined item (the FNP-539 backstop).
        items: response.data?.listBindingDriftReports?.items ?? [],
        nextToken: response.data?.listBindingDriftReports?.nextToken ?? null,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetBindingDriftReport>>({
        query: getBindingDriftReport,
        variables: {id: id},
    });
    return response.data?.getBindingDriftReport;
};
